
<div class="header-toolbar" *ngIf="operation">
  <h1>{{ operation.name }}</h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar" *ngIf="operation">

  <div class="btn-group" *ngIf="operation.revisions.length > 0">
    <span class="label">Révisions:</span>
    <div class="content">
      <button class="btn" (click)="add()">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </button>
    </div>
  </div>

  <div class="btn-group">
    <span class="label">Opération:</span>
    <div class="content">
      <a class="btn" [routerLink]="[ 'edit' ]">
        <t-icon name="mode_edit"></t-icon>
        <span class="text">Modifier</span>
      </a>
      <button class="btn" (click)="deleteOperation()" *ngIf="operation.executions_count === 0">
        <t-icon name="delete"></t-icon>
        <span class="text">Supprimer</span>
      </button>
    </div>
  </div>

</div>
<!-- /Toolbar -->

<table *ngIf="operation && operation.revisions.length > 0">

  <thead>
    <tr>
      <th>Révision</th>
      <th>État</th>
      <th>Créée par</th>
      <th>Nombre d'exécutions</th>
      <th>Dernière modif</th>
      <th style="width: 100px;"></th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let revision of operation.revisions" (click)="showDocuments(revision, $event)">
      <td name="Révision">{{ revision.name }}</td>
      <td name="État" style="width: 120px">
        {{ revision.statusString }}
      </td>
      <td name="Créée par" style="width: 150px">{{ revision.created_by.fullname }}</td>
      <td name="Nombre d'exécutions" class="text-center" style="width: 170px">
        {{ revision.executions_count }}
      </td>
      <td name="Dernière modif" style="width: 130px">{{ revision.updated_at | tzdate:'short' }}</td>
      <td style="width: 100px;" class="actions">

        <a class="action-btn" title="Publier" (click)="update(revision, 'PRODUCTION')" *ngIf="revision.status === 'DRAFT'">
          <t-icon name="check"></t-icon>
        </a>

        <a class="action-btn" title="Archiver" (click)="update(revision, 'ARCHIVE')" *ngIf="revision.status === 'PRODUCTION'">
          <t-icon name="archive"></t-icon>
        </a>

        <a class="action-btn" title="Restaurer" (click)="update(revision, 'PRODUCTION')" *ngIf="revision.status === 'ARCHIVE'">
          <t-icon name="settings_backup_restore"></t-icon>
        </a>

        <a class="action-btn" title="Supprimer" (click)="delete(revision)">
          <t-icon name="delete"></t-icon>
        </a>

      </td>
    </tr>
  </tbody>

</table>

<div *ngIf="operation && operation.revisions.length === 0" class="empty-table">

  <p>Aucune révision n'est définie par cette opération</p>

  <button class="btn" (click)="add()">
    <t-icon name="add"></t-icon>
    <span class="text">Ajouter une révision</span>
  </button>

</div>

<div *ngIf="!operation" class="empty-table">
  <p>Chargement...</p>
</div>